export const setting = "/web/v1/settings/content";
